import { createFileRoute } from '@tanstack/react-router'
import React from 'react'
import { BorderBox } from 'ui-v2'

export const Route = createFileRoute(
  '/impact-kpis/_layout/scope-1-and-2-emissions/supporting-metrics/',
)({
  component: EmissionsSupportingMetrics,
})

function EmissionsSupportingMetrics() {
  return <BorderBox>EmissionsSupportingMetrics</BorderBox>
}
